import {ServerHolder} from '../routes/contract-features-3/components/ContractFeatures';
import {
    AssociationScope,
    BoundingBox,
    CommonAssociationFeature,
    CopiableGeometryFeature,
    DisplayFeature,
    DisplayFeatureType,
    FeatureAttributeChange,
    GeometryType,
    Ground3dData,
    HeightReference,
    LockState,
    MessageResponse,
    Operation,
    SceneData, SidePosition,
    SidePositionEdit,
    SpecialAttribute,
    SubmitComment,
    UserSession
} from '../routes/contract-features-3/domain';
import {AssociatedFeature} from '../routes/contract-associations2/domain/AssociatedFeature';
import FeaturesState, {
    PopupType,
    PreserveFocusData,
    SortSetting
} from '../routes/contract-features-3/domain/FeaturesState';

import datacatalog, {AttributeType} from '../../integration/datacatalog/datacatalog-services';
import WKTParser from 'terraformer-wkt-parser';
import Terraformer from 'terraformer';
import {closeEditor, FeatureThunk, preserveFocus} from '../routes/contract-features-3/reducers/actions';

import {AnyAction} from 'redux';
import {ThunkAction, ThunkDispatch} from 'redux-thunk';
import AssociationsState, {FeatureTypeAttributes} from '../routes/contract-associations2/state/AssociationsState';
import {
    AssociationResult,
    AutomaticAssociationParameters,
    ManualAssociationParameters
} from '../../integration/representation/association';
import {Comment} from '../../integration/representation/contract';
import {FeatureTypeSummary, SkinnyFeatureType} from '../../integration/representation/feature-type';
import {ValidationIssue} from '../../integration/representation/validation-issue';
import {Definition} from '../routes/contract-associations2/domain/Definition';
import {IHttpPromise, IPromise} from 'angular';
import contractService from '../../service/contract/contract-services';
import {LaneUpdate} from '../../integration/representation/lane';
import {Feature} from '../../integration/representation/feature';
import {RoadSegment} from '../../integration/representation/road-segment';
import {Math} from 'three';
import {FeatureComments, OrderedComments} from '../routes/contract-features-3/selectors';
import MapUtils from '../map/map-utils';
import generateUUID = Math.generateUUID;
import {toRoadList} from '../formatters';

export enum ActionType {
    SELECT_CONTRACT,
    REQUEST_CONTRACT,
    RECEIVE_CONTRACT,
    ERROR_RECEIVE_CONTRACT,
    SELECT_FEATURE_TYPE,
    UNSELECT_FEATURE_TYPE,
    SET_FEATURES,
    SET_SELECTED_FEATURES,
    SELECT_FEATURES,
    UNSELECT_FEATURES,
    FETCH_FEATURE_TYPE,
    RECEIVE_FEATURE_TYPE,
    RECEIVE_ADDITIONAL_FEATURE_TYPE,
    ERROR,
    DELETE_FEATURE,
    FEATURES_DELETED,
    RESOLVE_ISSUE,
    ISSUES_RESOLVED,
    EDIT_ATTRIBUTE,
    EDIT_ATTRIBUTE_LOCALLY,
    COPY_ATTRIBUTE_VALUE,
    LOCK_FEATURE_TYPE,
    LOCK_FEATURE,
    SET_COMMENTS,
    REPLACE_COMMENT_FEATURE_TYPE,
    COMMENT_FEATURE_TYPE,
    REPLACE_COMMENT_FEATURE,
    COMMENT_FEATURE,
    DELETE_COMMENTS,
    SHOW_EXISTING_FEATURES,
    RECEIVE_EXISTING_FEATURES,
    ENABLE_SHOW_EXISTING_FEATURES,
    REMOVE_EXISTING_FEATURES,
    GO_HOME,
    RECEIVE_CLOSINGS,
    RECEIVE_USER,
    TOGGLE_FULLSCREEN,
    TOGGLE_SPLITSCREEN,
    ENABLE_GEOMETRY_EDIT,
    CLOSING_FEATURE_GEOMETRY_EDITOR,
    CHANGE_GROUND3D_DATA,
    CHANGE_SCENE_DATA,
    CHANGE_ACTIVE_TAB,
    ASSOCIATIONS_RECEIVED,
    ASSOCIATION_SELECT,
    ASSOCIATION_UNSELECT,
    ASSOCIATIONS_RECEIVE_POTENTIAL_CHILDREN_TYPES,
    ASSOCIATIONS_RECEIVE_POTENTIAL_CHILDREN,
    UPDATE_ASSOCIATION_TARGETS,
    ASSOCIATIONS_SELECT_TARGET_TYPE,
    ASSOCIATIONS_CLEAR_POTENTIAL_CHILDREN,
    ASSOCIATIONS_RECEIVE_ATTRIBUTE_POPOVER,
    ASSOCIATIONS_SET_NVDB_FEATURE_TYPES,
    AUTOASSOCIATION_SET_FEEDBACK_TEXT,
    ASSOCIATIONS_SET_NVDB_MAX_SEARCH_DISTANCE,
    FETCH_DATACATALOG,
    START_FETCHING,
    STOP_FETCHING,
    UPDATE_SIDE_POSITION,
    SET_LOADING_ATTRIBUTES,
    SET_LOADING_SPECIAL_ATTRIBUTES,

    URL_HAS_SENSITIVE_ATTRIBUTES,

    FEATURETAB3_NAVIGATE,
    FEATURETAB3_SHOW_EDITOR,
    FEATURETAB3_CLOSE_EDITOR,
    FEATURETAB3_SORT_FEATURES,
    FEATURETAB3_DESELECT_ALL_FEATURES,
    FEATURETAB3_SET_SHOW_SUBMITTED_FEATURES,
    FEATURETAB3_PRESERVE_FOCUS,
    FEATURETAB3_ONLY_SHOW_OBJECTLIST_ATTRIBUTES,
    FEATURETAB3_SHOW_QUALITY_PARAMS,
    FEATURETAB3_SET_SHOW_ONLY_SELECTD_FEATURES,
    FEATURETAB3_SET_TYPE_MODIFIED,
    FEATURETAB3_SHOW_NVDB_IMPORT_MODAL,
    FEATURETAB3_SET_MISSING_ATTRIBUTE_TYPES,
    FEATURETAB3_SET_FETCHING_MISSING_ATTRIBUTE_TYPES,
    FEATURETAB3_SET_COPY_GEOMETRY_MODAL_VISIBLE,
    FEATURETAB3_SET_COPIABLE_FEATURES,
    FEATURETAB3_SET_FETCHING_COPIABLE_FEATURES,
    FEATURETAB3_SET_COPYING_GEOMETRY_FEATURES,
    FEATURETAB3_SET_FETCHING_SENSITIVE_ATTRIBUTE_TYPES,
    FEATURE_TAB3_SET_COMMENTS_MODAL_VISIBLE,
    FEATURE_TAB3_SET_COMMENTS_FILTER,
    FEATURE_TAB3_SET_MARKED_COMMENTS,
    FEATURE_TAB3_SET_FEATURE_OR_TYPE_FOR_COMMENTS,
    FEATURE_TAB3_SET_ROAD_REFS,
    FEATURE_TAB3_SET_SELECTED_ROAD_REF,
    FEATURE_TAB3_SET_CREATE_OBJECT_VISIBLE,
    FEATURE_TAB3_SET_CREATE_OBJECT_TYPE_ID,
    FEATURE_TAB3_SET_CREATE_OBJECT_WKT,
    FEATURE_TAB3_SET_REFERENCE_ERROR,
    FEATURE_TAB3_SET_CREATING_OBJECT_GEOMETRY,

    SET_ROAD_SYSTEM_REFERENCES,

    SET_POPUP,
    SET_SHOW_DESCRIPTION_INSTEAD_OF_NAME,

    SET_FEATURES_PAGE,
    SET_FEATURES_PAGE_SIZE,
    SET_FEATURE_SEARCH
}

// Default function type for the action return functions, aka. (dispatch, getState, serverHolder) => void

// This type is for the actions working on AssociationsState
export type AssociationsThunk = ThunkAction<void, AssociationsState, ServerHolder, AnyAction>;
export type AssociationsDispatch = ThunkDispatch<AssociationsState, ServerHolder, AnyAction>;

export type CommonThunk = ThunkAction<void, AssociationsState | FeaturesState, ServerHolder, AnyAction>;
export type CommonDispatch = ThunkDispatch<AssociationsState | FeaturesState, ServerHolder, AnyAction>;

// Attributes types to skip when formatting vegobjekt attributes from NVDB for display
const nvdbEgenskapstypeSkip = ['Stedfesting', 'Geometri', 'Liste'];

export type AutoAssociate = (associationParams: AutomaticAssociationParameters) => AssociationsThunk;
export const autoAssociate: AutoAssociate = (associationParams) => (dispatch, getState, serverHolder) => {
    dispatch({type: ActionType.START_FETCHING});
    serverHolder.server.createAssociations(getState().contractId, associationParams).then((response) => {
        const numberOfRoadObjectsWithUpdatedLocational = response.roadObjectsWithUpdatedLocational.length;
        if (numberOfRoadObjectsWithUpdatedLocational > 0) {
            serverHolder.contract.showMessage.info(numberOfRoadObjectsWithUpdatedLocational + ' ' +
                (numberOfRoadObjectsWithUpdatedLocational == 1 ? 'vegobjekt' : 'vegobjekter') + ' fikk ny stedfesting.');
        }
        dispatch(requestAssociations(getState().contractId));
        if (response.addedRoadObjectIds && response.addedRoadObjectIds.length > 0) {
            updateFeatureTypes(getState().contractId, serverHolder, dispatch);
        }
        dispatch({type: ActionType.STOP_FETCHING});
        dispatch({
            type: ActionType.AUTOASSOCIATION_SET_FEEDBACK_TEXT,
            autoAssociateCount: response.associations.length
        });

    });
};

export type ClearAutoAssociationFeedback = () => AssociationsThunk;
export const clearAutoAssociationFeedback: ClearAutoAssociationFeedback = () => (dispatch) => {
    dispatch({
        type: ActionType.AUTOASSOCIATION_SET_FEEDBACK_TEXT,
        autoAssociateCount: -1
    });
};

export type SetNvdbSearchDistance = (maxDistance: number) => AssociationsThunk;
export const setNvdbSearchDistance: SetNvdbSearchDistance = (maxDistance) => (dispatch) => {
    dispatch({
        type: ActionType.ASSOCIATIONS_SET_NVDB_MAX_SEARCH_DISTANCE,
        nvdbSearchDistance: maxDistance
    });
};

export type SelectTargetFeatureType = (featureType: SkinnyFeatureType | DisplayFeatureType) => AssociationsThunk;
export const selectTargetFeatureType: SelectTargetFeatureType = (featureType) => (dispatch, getState) => {
    dispatch({
        type: ActionType.ASSOCIATIONS_SELECT_TARGET_TYPE,
        featureType
    });
    if (featureType) {
        dispatch(loadTargetFeatures(getState().contractId, featureType.typeId));
    } else {
        dispatch(clearTargetFeatures());
    }
};

export type ToggleSelectedAssociationTarget = (feature: CommonAssociationFeature) => AssociationsThunk;
export const toggleSelectedAssociationTarget: ToggleSelectedAssociationTarget = (feature) => (dispatch, getState) => {
    const targets = getState().selectedTargetFeatures;
    const filtered = targets.filter(target => target.id != feature.id);

    if (filtered.length == targets.length) {
        filtered.push(feature);
    }

    dispatch({
        type: ActionType.UPDATE_ASSOCIATION_TARGETS,
        targets: filtered
    });

};

const clearSelectedTargetFeatureType = (): AnyAction => ({
    type: ActionType.ASSOCIATIONS_SELECT_TARGET_TYPE,
    featureType: null
});

const clearSelectedTargets = (): AnyAction => ({
    type: ActionType.UPDATE_ASSOCIATION_TARGETS,
    targets: []
});

// This action is harder to type - we get into a Feature != CommonAssociationFeature in getAssociationParams()
export type AssociateTargets = (scope: AssociationScope) => AssociationsThunk;
export const associateTargets: AssociateTargets = (scope) => (dispatch, getState, serverHolder) => {
    const state = getState();
    const parentAssociation = state.selectedAssociation;
    const parentFeature = state.selectedSourceFeature;
    const children = state.selectedTargetFeatures;

    const tasks: IPromise<AssociationResult>[] = [];

    const c = children.filter((child) => {
        return !parentAssociation.childFeatures.some((existingAssociation) => {
            return existingAssociation.id === child.id;
        });
    });

    c.forEach(child => {
        // XXX The typings for AssociationState does not fully reflect reality, so need this to make it work. See comments in AssociationState.
        const params = getAssociationParams(scope, parentFeature as any, child);
        tasks.push(serverHolder.server.createAssociationManually(getState().contractId, params));
    });

    Promise.all(tasks).then((results) => {
        const messages = getAssociationResultMessages(results, serverHolder.contract);

        messages.info.forEach(msg => {
            serverHolder.contract.showMessage.info(msg);
        });

        messages.errors.forEach(msg => {
            serverHolder.contract.showMessage.danger(msg);
        });

        const addedFeatures = results.some(result => result.addedRoadObjectIds && result.addedRoadObjectIds.length > 0);

        dispatch(requestAssociations(getState().contractId));
        if (addedFeatures) {
            updateFeatureTypes(getState().contractId, serverHolder, dispatch);
        }
        dispatch(clearSelectedTargets());
    });
};

function updateFeatureTypes(contractId: string, serverHolder: ServerHolder, dispatch: AssociationsDispatch): void {
    serverHolder.contract.reloadContract();
    serverHolder.server.getFeatureTypeSummary(contractId)
        .then(featureTypeSummary => dispatch(receiveContract(contractId, featureTypeSummary)));
        // Errors are handled by Angular interceptor
}

interface GroupedMessages {
    info: string[];
    errors: string[];
}

function getAssociationResultMessages(associationResults: AssociationResult[], contract: contractService): GroupedMessages {

    const messages: GroupedMessages = {
        info: [],
        errors: []
    };

    const featureList = contract.featureList;
    let numberOfSuccessfulAssociations = 0;

    associationResults.forEach(associationResult => {
        const result = associationResult;

        if (result) {
            numberOfSuccessfulAssociations += result.associations.length;

            // childrenIdsExceedingParentLinks
            result.childrenIdsExceedingParentLinks.forEach(id => {
                const feature = featureList.getFeatureById(id);
                messages.errors.push(`Feil: ${feature.alias} ligger ikke på morobjektets veglenke`);
            });

            // parentIdsWithTooFarOffChildren
            result.parentIdsWithTooFarOffChildren.forEach(id => {
                const feature = featureList.getFeatureById(id);
                if (feature) {
                    messages.errors.push(`Feil: ${feature.alias} (mor) ligger for langt unna en eller flere av døtrene`);
                } else {
                    messages.errors.push('Feil: Mor ligger for langt unna en eller flere av døtrene.');
                }
            });
        } else {
            messages.errors.push('Det har oppstått en feil med sammenkoblingen. last prosjektet på nytt og prøv igjen');
        }


    });

    messages.info.push(`${numberOfSuccessfulAssociations} ${numberOfSuccessfulAssociations === 1 ? 'vegobjekt' : 'vegobjekter'}  ble koblet sammen`);


    return messages;

}


const getAssociationParams = (scope: AssociationScope, sourceFeature: CommonAssociationFeature,
                              targetFeature: CommonAssociationFeature): ManualAssociationParameters => {
    const associationParams: ManualAssociationParameters = {
        scope: null,
        parentFeatureId: null,
        parentTypeId: null,
        childFeatureId: null,
        childTypeId: null,
        parentNvdbId: null,
        parentNvdbVersion: null,
        childNvdbId: null,
        childNvdbVersion: null
    };

    switch (scope) {
        case 'PROJECT_TO_PROJECT':
            associationParams.scope = scope;
            associationParams.parentFeatureId = sourceFeature.id;
            associationParams.parentTypeId = sourceFeature.typeId;

            associationParams.childFeatureId = targetFeature.id;
            associationParams.childTypeId = targetFeature.typeId;
            break;

        case 'PROJECT_TO_NVDB':
            associationParams.scope = scope;
            associationParams.parentFeatureId = sourceFeature.id;
            associationParams.parentTypeId = sourceFeature.typeId;

            associationParams.childTypeId = targetFeature.typeId;
            associationParams.childNvdbId = parseInt(targetFeature.id);
            associationParams.childNvdbVersion = targetFeature.version;
            break;

        case 'NVDB_TO_PROJECT':
            associationParams.scope = scope;
            associationParams.parentTypeId = targetFeature.typeId;
            associationParams.parentNvdbId = parseInt(targetFeature.id);
            associationParams.parentNvdbVersion = targetFeature.version;

            associationParams.childFeatureId = sourceFeature.id;
            associationParams.childTypeId = sourceFeature.typeId;
            break;

        case 'NVDB_ASSOCIATION_TO_PROJECT_CHILD':
            associationParams.scope = 'NVDB_TO_PROJECT';
            associationParams.parentTypeId = sourceFeature.typeId;
            associationParams.parentNvdbId = parseInt((sourceFeature as CommonAssociationFeature).id);
            associationParams.parentNvdbVersion = (sourceFeature as CommonAssociationFeature).version;

            associationParams.childFeatureId = targetFeature.id;
            associationParams.childTypeId = targetFeature.typeId;

            break;


    }

    return associationParams;
};

export type DisAssociateTargets = () => AssociationsThunk;
export const disAssociateTargets: DisAssociateTargets = () => (dispatch, getState, serverHolder) => {

    const mother = getState().selectedAssociation;
    const targets = getState().selectedTargetFeatures;
    const contractId = getState().contractId;

    const disAsscociateTasks: IHttpPromise<void>[] = [];

    mother.childFeatures.forEach((association) => {
        if (targets.some((target) => target.id === association.id)) {
            disAsscociateTasks.push(serverHolder.server.deleteAssociation(contractId, association.associationId));
        }
    });

    Promise.all(disAsscociateTasks).then(() => {
        dispatch(requestAssociations(getState().contractId));
        dispatch(clearSelectedTargets());
    });
};

export type DisAssociate = (associationId: string) => AssociationsThunk;
export const disAssociate: DisAssociate = (associationId) => ((dispatch, getState, serverHolder) => {
    const contractId = getState().contractId;
    serverHolder.server.deleteAssociation(contractId, associationId).then(() => {
        dispatch(requestAssociations(getState().contractId));
    });
});

export type ReAssociate = (associationId: string) => AssociationsThunk;
export const reAssociate: ReAssociate = (associationId) => ((dispatch, getState, serverHolder) => {
    const contractId = getState().contractId;
    serverHolder.server.undeleteAssociation(contractId, associationId).then(() => {
        dispatch(requestAssociations(getState().contractId));
    });
});

export type RequestPotentialAssociationChildrenTypes = (featureTypeId: number) => AssociationsThunk;
export const requestPotentialAssociationChildrenTypes: RequestPotentialAssociationChildrenTypes = (featureTypeId) => (dispatch, getState, serverHolder) => {
    const datacatalog: datacatalog = serverHolder.datacatalog;
    let skinnyTypes: FeatureTypeAttributes[];
    let associationTypes;
    switch (getState().tab) {
        case 'PROJECT_TO_PROJECT':
            associationTypes = datacatalog.getAssociationTypesByParent(featureTypeId);
            const childTypes = associationTypes.map(associationType => datacatalog.getFeatureType(associationType.childFeatureTypeId));

            skinnyTypes = childTypes
                .filter(targetType => getState().featureTypes.some(featureType => featureType.typeid == targetType.id))
                .map(type => ({typeId: type.id, name: type.name, sortNo: type.sortNum, attributes: type.attributeTypes}));
            break;

        case 'PROJECT_TO_NVDB':
            associationTypes = datacatalog.getAssociationTypesByParent(featureTypeId);
            const nvdbChildTypes = associationTypes.map(associationType => datacatalog.getFeatureType(associationType.childFeatureTypeId));
            skinnyTypes = nvdbChildTypes.map(type => ({typeId: type.id, name: type.name, sortNo: type.sortNum, attributes: type.attributeTypes}));
            break;

        case 'NVDB_TO_PROJECT':
            associationTypes = datacatalog.getAssociationTypesByChild(featureTypeId);
            const parentTypes = associationTypes.map(associationType => datacatalog.getFeatureType(associationType.parentFeatureTypeId));
            skinnyTypes = parentTypes.map(type => ({typeId: type.id, name: type.name, sortNo: type.sortNum, attributes: type.attributeTypes}));

            break;
    }

    // sort by priority from datakatalogen
    const sortedSkinnyTypes = skinnyTypes.sort((a, b) => {
        return b.sortNo - a.sortNo;
    });

    dispatch(setTargetAssociationTypes(sortedSkinnyTypes));

    // if new list of target types contains the already selected feature type, we keep the selected one
    const selectedTargetFeatureType = getState().selectedAssociationTargetType;
    if (!selectedTargetFeatureType || !sortedSkinnyTypes.some(t => t.typeId === selectedTargetFeatureType.typeId)) {
        dispatch(selectTargetFeatureType(sortedSkinnyTypes[0]));
    } else {
        dispatch(loadTargetFeatures(getState().contractId, selectedTargetFeatureType.typeId));
    }

    dispatch(clearSelectedTargets());
};

export type SetTargetAssociationTypes = (featureTypes: SkinnyFeatureType[]) => AssociationsThunk;
const setTargetAssociationTypes: SetTargetAssociationTypes = (featureTypes) => (dispatch) => {
    dispatch({
        type: ActionType.ASSOCIATIONS_RECEIVE_POTENTIAL_CHILDREN_TYPES,
        targetAssociationTypes: featureTypes
    });
};

export type LoadTargetFeatures = (contractId: string, featureTypeId: number) => AssociationsThunk;
const loadTargetFeatures: LoadTargetFeatures = (contractId, featureTypeId) => (dispatch, getState) => {
    switch (getState().tab) {
        case 'PROJECT_TO_PROJECT':
            dispatch(fetchFeatures(contractId, featureTypeId, receiveTargetAssociationCandidates));
            break;
        case 'NVDB_TO_PROJECT':
        case 'PROJECT_TO_NVDB':
            dispatch(showEmptyTargetList());
            break;
    }
};

export type RequestAssociations = (contractId: string) => AssociationsThunk;
export const requestAssociations: RequestAssociations = (contractId) => (dispatch, getState, serverHolder) => {
    const datacatalog = serverHolder.datacatalog;
    serverHolder.server.readAssociationsMulti(contractId)
        .then(
            function (associations) {
                const associatedFeatures = associations;

                // some root associations have mothers in NVDB, we need to include these
                const nvdbRoots: FeatureTypeSummary[] = associatedFeatures.featureTree
                    .filter(a => {
                        return a.origin === 'NVDB';
                    })
                    .map(a => {
                        const ft = datacatalog.getFeatureType(a.featureTypeId);
                        const fts: FeatureTypeSummary =  {
                            name: ft.name, typeid: ft.id, sortNum: ft.sortNum, aggregatedErrors: null,
                            numFeatures: -1, numFeatureTypeComments: -1, numFeatureComments: -1, childTypes: [], parentTypes: [], geometryTypes: [],
                            isDirty: false, isExporting: false, isLocked: false
                        };
                        return fts;
                    });

                const uniqueNvdbRoots: FeatureTypeSummary[] = [];

                nvdbRoots.forEach(type => {
                    const exists = uniqueNvdbRoots.some(uniqueType => {
                        return uniqueType.typeid === type.typeid;
                    });
                    if (!exists) {
                        uniqueNvdbRoots.push(type);
                    }
                });

                dispatch(setNvdbFeatureTypes(uniqueNvdbRoots as any));

                dispatch({
                    type: ActionType.ASSOCIATIONS_RECEIVED,
                    associatedFeatures
                });
            });
};

export type SetNvdbFeatureTypes = (nvdbFeatureTypes: DisplayFeatureType) => AssociationsThunk;
export const setNvdbFeatureTypes: SetNvdbFeatureTypes = (nvdbFeatureTypes) => (dispatch) => {
    dispatch({
        type: ActionType.ASSOCIATIONS_SET_NVDB_FEATURE_TYPES,
        nvdbFeatureTypes
    });
};

export type SelectContract = (contractId: string) => AssociationsThunk;
export const selectContract: SelectContract = (contractId) => (dispatch) => {
    dispatch({
        type: ActionType.SELECT_CONTRACT,
        contractId
    });
    dispatch(requestUserSession());
    return dispatch(requestContract(contractId));
};

const receiveUser = (user: UserSession): AnyAction => ({
    type: ActionType.RECEIVE_USER,
    user
});

export type RequestUserSession = () => AssociationsThunk;
export const requestUserSession: RequestUserSession = () => (dispatch, getState, serverHolder) => {
    serverHolder.security.ensureCurrentUser()
        .then(userSession => dispatch(receiveUser(userSession)),
            err => dispatch(handleError({}, 'Error fetching user')));
};

export type RequestContract = (contractId: string) => CommonThunk;
export const requestContract: RequestContract = (contractId: string) => (dispatch, getState, serverHolder) => {
    dispatch({
        type: ActionType.REQUEST_CONTRACT,
        contractId
    });
    serverHolder.contract.reloadContract();
    return dispatch(fetchContract(contractId));
};

export type FetchContract = (contractId: string) => AssociationsThunk;
const fetchContract: FetchContract = (contractId) => (dispatch, getState, {server, security}) => {
    const userSessionPromise = security.ensureCurrentUser();
    const featureTypeSummaryPromise = server.getFeatureTypeSummary(contractId);
    Promise.all([userSessionPromise, featureTypeSummaryPromise])
        .then(responses => {
                const userSession: UserSession = responses[0];
                dispatch(receiveUser(userSession));

                const featureTypeSummary: FeatureTypeSummary[] = responses[1];
                return dispatch(receiveContract(contractId, featureTypeSummary));
            },
            error => dispatch(errorGettingContract(contractId)));
};

const receiveContract = (contractId: string, featureTypeSummary: FeatureTypeSummary[]): AnyAction => ({
    type: ActionType.RECEIVE_CONTRACT,
    contractId,
    featureTypes: featureTypeSummary
});

const errorGettingContract = (contractId: string): AnyAction => ({
    type: ActionType.ERROR_RECEIVE_CONTRACT,
    contractId
});

export type ToggleAssociation = (association: AssociatedFeature) => AssociationsThunk;
export const toggleAssociation: ToggleAssociation = (association) => async (dispatch, getState, serverHolder) => {
    const preSelectedSourceFeature = getState().selectedSourceFeature;
    const preSelectedAssociation = getState().selectedAssociation;
    const sameType = !!getState().selectedSourceFeature && (getState().selectedSourceFeature.typeId == association.featureTypeId);

    const selectedFeature = preSelectedSourceFeature && preSelectedSourceFeature.id === association.id ? null
        : serverHolder.contract.featureList.getFeatureById(association.id);

    const selectedAssociation = preSelectedAssociation && preSelectedAssociation.id === association.id ? null : association;

    // Fetch info for selected Association
    if (selectedAssociation) {
        // clear any old popover data
        dispatch({
            type: ActionType.ASSOCIATIONS_RECEIVE_ATTRIBUTE_POPOVER,
            attributePopoverData: []
        });

        let dispatchFeature: CommonAssociationFeature | Feature;
        let attrData: Definition[];

        if (selectedAssociation.origin === 'NVDB') {
            // We need to get the feature from NVDB API
            const featureIdBase = parseInt(selectedAssociation.id.split(':')[0]);
            const vegobjekt = await serverHolder.nvdbapi.getVegobjekt(selectedAssociation.featureTypeId, featureIdBase);
            dispatchFeature = serverHolder.nvdbapi.toCommonAssociationFeature(vegobjekt);

            // Map attributes for display
            attrData = vegobjekt.egenskaper
                .filter(e => !nvdbEgenskapstypeSkip.includes(e.egenskapstype))
                .map(egenskap => ({name: egenskap.navn, value: egenskap.verdi} as Definition));
            attrData.push({name: 'NVDB-referanse', value: association.name});

        } else {
            // association from contract
            dispatchFeature = selectedFeature;

            const featureType = serverHolder.datacatalog.getFeatureType(association.featureTypeId);
            const attributeTypes = featureType.attributeTypes;

            attrData = [];
            for (const [attrTypeId, attr] of Object.entries(selectedFeature.attributes)) {
                attrData.push({name: attributeTypes[attrTypeId].name, value: attr.value});
            }

        }

        dispatch(selectAssociationAction(selectedAssociation, dispatchFeature));
        dispatch({
            type: ActionType.ASSOCIATIONS_RECEIVE_ATTRIBUTE_POPOVER,
            attributePopoverData: attrData
        });

        if (getState().tab == null) {
            dispatch({
                type: ActionType.CHANGE_ACTIVE_TAB,
                tab: 'PROJECT_TO_PROJECT'
            });
        }

        if (!sameType) {
            dispatch(requestPotentialAssociationChildrenTypes(association.featureTypeId));
        }

    } else {
        dispatch({
            type: ActionType.ASSOCIATION_UNSELECT
        });
        dispatch({
            type: ActionType.ASSOCIATIONS_RECEIVE_ATTRIBUTE_POPOVER,
            attributePopoverData: []
        });
    }
};

const selectAssociationAction = (association: AssociatedFeature, feature: CommonAssociationFeature | Feature): AnyAction => ({
    type: ActionType.ASSOCIATION_SELECT,
    selection: association,
    sourceFeature: feature
});


export type SelectFeatureType = (featureTypeId: number, force: boolean) => FeatureThunk;
export const selectFeatureType: SelectFeatureType = (featureTypeId, force = false) => (dispatch, getState) => {
    const state: FeaturesState = getState();
    const selectedFeatureType = state.selectedFeatureType;
    if (!selectedFeatureType || selectedFeatureType.typeId != featureTypeId || force) {
        dispatch({
            type: ActionType.UNSELECT_FEATURE_TYPE
        });
        dispatch({
            type: ActionType.SELECT_FEATURE_TYPE,
            featureTypeId
        });
        dispatch({
            type: ActionType.FETCH_FEATURE_TYPE,
            contractId: state.contractId,
            featureTypeId
        });
        dispatch(fetchFeatures(state.contractId, featureTypeId));
    }
};

export type ToggleAdditionalFeatureType = (featureTypeId: number) => FeatureThunk;
export const toggleAdditionalFeatureType: ToggleAdditionalFeatureType = (featureTypeId) => (dispatch, getState) => {
    const state = getState();
    const notSelected = state.additionalSelectedFeatureTypes.map(ft => ft.typeId).indexOf(featureTypeId) == -1;
    if (notSelected) {
        dispatch({
            type: ActionType.FETCH_FEATURE_TYPE,
            contractId: state.contractId,
            featureTypeId
        });
        dispatch(fetchFeatures(state.contractId, featureTypeId, receiveAdditionalFeatureType));
    } else {
        dispatch(removeAdditionalFeatureType(featureTypeId));
    }
};

export type SetFeatures = (features: DisplayFeature[]) => FeatureThunk;
export const setFeatures: SetFeatures = (features) => dispatch => dispatch({
    type: ActionType.SET_FEATURES,
    features
});

export type EditAttributeLocally = (change: FeatureAttributeChange) => FeatureThunk;
export const editAttributeLocally: EditAttributeLocally = (change) => dispatch => dispatch({
    type: ActionType.EDIT_ATTRIBUTE_LOCALLY,
    change
});

export type ReloadSummaryAndSelectedFeatures = (dispatch: CommonDispatch, contractId: string, selectedFeatureType: DisplayFeatureType, additionalSelectedFeatureTypes: DisplayFeatureType[]) => void;
const reloadSummaryAndSelectedFeatures: ReloadSummaryAndSelectedFeatures = (dispatch, contractId: string, selectedFeatureType: DisplayFeatureType, additionalSelectedFeatureTypes) => {
    dispatch(requestContract(contractId));
    dispatch(reloadSelectedFeatures(contractId, selectedFeatureType.typeId));
    additionalSelectedFeatureTypes.map(type => type.typeId)
        .forEach((typeId) => {
            dispatch(fetchFeatures(contractId, typeId, receiveAdditionalFeatureType));
        });
};

const reloadSelectedFeatures = (contractId: string, featureTypeId: number) => (dispatch: CommonDispatch) => {
    dispatch({
        type: ActionType.FETCH_FEATURE_TYPE,
        contractId,
        featureTypeId
    });
    dispatch(fetchFeatures(contractId, featureTypeId));
};

export type OnDeleteFeature = (objectId: string, deleteSelected: boolean) => FeatureThunk;
export const onDeleteFeature: OnDeleteFeature = (objectId: string, deleteSelected: boolean) => (dispatch, getState) => {
    const state: FeaturesState = getState();

    let deleteObjects = [objectId];
    if (deleteSelected) {
        deleteObjects = deleteObjects.concat(state.selectedFeatures.filter(fid => fid != objectId));
    }
    dispatch({
        type: ActionType.DELETE_FEATURE,
        objectIds: deleteObjects
    });
    dispatch(deleteFeature(state.contractId, deleteObjects));
};

export type DeleteSelectedFeatures = () => FeatureThunk;
export const deleteSelectedFeatures: DeleteSelectedFeatures = () => (dispatch, getState) => {
    const state: FeaturesState = getState();
    const contractId = state.contractId;
    const selectedFeatureIds = state.selectedFeatures;

    dispatch({
        type: ActionType.DELETE_FEATURE,
        objectIds: selectedFeatureIds
    });
    dispatch(deleteFeature(contractId, selectedFeatureIds));


};


export type SidepositionFromParents = (features: DisplayFeature[]) => FeatureThunk;
export const sidepositionFromParents: SidepositionFromParents = (features) => async (dispatch, getState, serverHolder) => {
    dispatch(setSpecialAttributesLoading(features.map(feature => ({featureId: feature.id, specialAttribute: 'SIDEPOSISJON', isLoading: true}))));
    const state = getState();
    const contractId = state.contractId;
    const featureIds = features.map(feature => feature.id);
    serverHolder.server.addSidePositionFromParent(contractId, featureIds).then(updatedFeatures => {
        const newFeatures: DisplayFeature[] = getDisplayFeaturesFromUpdatedFeatures(state.features, updatedFeatures);
        dispatch(setFeatures(newFeatures));
        const message = updatedFeatures.length + ' av ' + featureIds.length +
            (featureIds.length === 1 ? ' sideposisjon' : ' sideposisjoner') + ' ble kopiert fra mor';
        serverHolder.contract.showMessage.info(message);
    })
        .finally(() => {
            dispatch(setSpecialAttributesLoading(features.map(feature => ({featureId: feature.id, specialAttribute: 'SIDEPOSISJON', isLoading: false}))));
        });
};

export type OnResolveIssue = (issue: ValidationIssue, resolveSimilar: boolean) => FeatureThunk;
export const onResolveIssue: OnResolveIssue = (issue, resolveSimilar) => (dispatch) => {
    dispatch({
        type: ActionType.RESOLVE_ISSUE,
        issue
    });
    dispatch(resolveIssue(issue, resolveSimilar));
};

export type ResolveIssue = (issue: ValidationIssue, resolveSimilar: boolean) => FeatureThunk;
export const resolveIssue: ResolveIssue = (issue, resolveSimilar) => (dispatch, getState, serverHolder) => {
    const state = getState();
    const contractId = state.contractId;
    const selectedFeatureType = state.selectedFeatureType;
    serverHolder.server.resolveIssuesAsNotApplicable(contractId, issue.id, resolveSimilar)
        .then(idIssuesResolved => reloadSummaryAndSelectedFeatures(dispatch, contractId, selectedFeatureType, state.additionalSelectedFeatureTypes),
            err => dispatch(handleError({contractId, issue}, 'Error resolving issue')));
};
export type OnAttributeEdit = (change: FeatureAttributeChange) => FeatureThunk;
export const onAttributeEdit: OnAttributeEdit = (change: FeatureAttributeChange) => (dispatch) => {
    dispatch({
        type: ActionType.EDIT_ATTRIBUTE,
        change
    });
    dispatch(editAttribute(change));
    dispatch(closeEditor());
};

export type UpdateAllSidePositions = (sourceFeatureId: string, wantedSidePosition: SidePosition) => FeatureThunk;
export const updateAllSidePositions: UpdateAllSidePositions = (sourceFeatureId, wantedSidePosition) => (dispatch, getState, serverHolder) => {
    const {contractId, features} = getState();
    dispatch(setSpecialAttributesLoading(features.filter(feature => feature.id !== sourceFeatureId).map(feature => ({featureId: feature.id, specialAttribute: 'SIDEPOSISJON', isLoading: true}))));

    serverHolder.server.updateAllSidePositions(contractId, sourceFeatureId, wantedSidePosition, features.map(feature => feature.id))
        .then((updatedFeatures) => {
            const newFeatures: DisplayFeature[] = getDisplayFeaturesFromUpdatedFeatures(features, updatedFeatures);
            dispatch(setFeatures(newFeatures));
        })
        .finally(() => {
            dispatch(setSpecialAttributesLoading(features.map(feature => ({featureId: feature.id, specialAttribute: 'SIDEPOSISJON', isLoading: false}))));
        });
};


export type UpdateSidePositions = (updates: SidePositionEdit[]) => FeatureThunk;
export const updateSidePositions: UpdateSidePositions = (updates) => (dispatch, getState, serverHolder) => {
    const {contractId, features} = getState();

    dispatch(setSpecialAttributesLoading(updates.map(update => ({featureId: update.featureId, specialAttribute: 'SIDEPOSISJON', isLoading: true}))));

    serverHolder.server.updateSidePosition(contractId, updates)
        .then((updatedFeatures) => {
                const newFeatures: DisplayFeature[] = getDisplayFeaturesFromUpdatedFeatures(features, updatedFeatures);
                dispatch(setFeatures(newFeatures));
            },
            err => dispatch(handleError({contractId, updates}, 'Det oppstod en feil ved endring av sideposisjon')))
        .finally(() => {
            dispatch(setSpecialAttributesLoading(updates.map(update => ({featureId: update.featureId, specialAttribute: 'SIDEPOSISJON', isLoading: false}))));
        });
};

export type EditAllLanes = (sourceFeatureId: string, wantedLane: string) => FeatureThunk;
export const editAllLanes: EditAllLanes = (sourceFeatureId, wantedLane) => (dispatch, getState, serverHolder) => {
    const {contractId, features} = getState();
    dispatch(closeEditor());
    const idsToChange = features.filter(feature => feature.id !== sourceFeatureId).map(feature => feature.id);
    dispatch(setSpecialAttributesLoading(idsToChange.map(featureId => ({featureId, specialAttribute: 'FELT', isLoading: true}))));
    serverHolder.server.updateAllLanes(contractId, sourceFeatureId, wantedLane, [sourceFeatureId, ...idsToChange])
        .then(updatedFeatures => {
            const newFeatures: DisplayFeature[] = getDisplayFeaturesFromUpdatedFeatures(features, updatedFeatures);
            dispatch(setFeatures(newFeatures));
        })
        .finally(() => {
            dispatch(setSpecialAttributesLoading(idsToChange.map(featureId => ({featureId, specialAttribute: 'FELT', isLoading: false}))));
        });
};


export type EditLanes = (laneUpdates: LaneUpdate[]) => FeatureThunk;
export const editLanes: EditLanes = (laneUpdates) => (dispatch, getState, serverHolder) => {
    dispatch(closeEditor());
    dispatch(setSpecialAttributesLoading(laneUpdates.map(laneUpdate => ({featureId: laneUpdate.featureId, specialAttribute: 'FELT', isLoading: true}))));
    const state = getState();
    const contractId = state.contractId;
    serverHolder.server.updateLane(contractId, laneUpdates)
        .then((updatedFeatures) => {
                const newFeatures: DisplayFeature[] = getDisplayFeaturesFromUpdatedFeatures(state.features, updatedFeatures);
                dispatch(setFeatures(newFeatures));
            },
            err => dispatch(handleError({contractId, laneUpdates}, 'Error updating lane')))
        .finally(() => {
            dispatch(setSpecialAttributesLoading(laneUpdates.map(laneUpdate => ({featureId: laneUpdate.featureId, specialAttribute: 'FELT', isLoading: false}))));
        });
};

export type EditHeightReference = (featureId: string, heightReference: HeightReference) => FeatureThunk;
export const editHeightReference: EditHeightReference = (featureId, heightReference) => (dispatch, getState, serverHolder) => {
    const state = getState();
    const contractId = state.contractId;

    dispatch(setSpecialAttributesLoading([{ featureId, specialAttribute: 'HØYDEREFERANSE', isLoading: true }]));

    serverHolder.server.updateHeightReference(contractId, featureId, heightReference)
        .then((updatedFeature) => {
                const newFeatures: DisplayFeature[] = getDisplayFeaturesFromUpdatedFeatures(getState().features, [updatedFeature]);
                dispatch(setFeatures(newFeatures));
            },
            err => dispatch(handleError({contractId, heightReference}, 'Error updating height reference')))
        .finally(() => {
                dispatch(setSpecialAttributesLoading([{ featureId, specialAttribute: 'HØYDEREFERANSE', isLoading: false }]));
        });
};

type LoadingAttribute = {
    featureId: string;
    attributeTypeId: number;
    isLoading: boolean;
};
export type SetAttributesLoading = (loadingAttributes: LoadingAttribute[]) => FeatureThunk;
export const setAttributesLoading: SetAttributesLoading = (newLoadingAttributes) => (dispatch, getState) => {
    const {loadingAttributes} = getState();
    const newAttributesLoading = {
        ...loadingAttributes,
        ...newLoadingAttributes.reduce((prev, curr) => ({
            ...prev,
            [curr.featureId]: prev[curr.featureId] ? {...prev[curr.featureId], [curr.attributeTypeId]: curr.isLoading} : {[curr.attributeTypeId]: curr.isLoading}
        }), {} as Record<string, Record<number, boolean>>)
    };
    dispatch({
        type: ActionType.SET_LOADING_ATTRIBUTES,
        loadingAttributes: newAttributesLoading
    });
};

type LoadingSpecialAttribute = Omit<LoadingAttribute, 'attributeTypeId'> & {specialAttribute: SpecialAttribute};
export type SetSpecialAttributesLoading = (loadingSpecialAttributes: LoadingSpecialAttribute[]) => FeatureThunk;
export const setSpecialAttributesLoading: SetSpecialAttributesLoading = (newLoadingSpecialAttributes) => (dispatch, getState) => {
    const {loadingSpecialAttributes} = getState();
    const newAttributesLoading = {
        ...loadingSpecialAttributes,
        ...newLoadingSpecialAttributes.reduce((prev, curr) => ({
            ...prev,
            [curr.featureId]: prev[curr.featureId] ? {...prev[curr.featureId], [curr.specialAttribute]: curr.isLoading} : {[curr.specialAttribute]: curr.isLoading}
        }), {} as Record<string, Record<SpecialAttribute, boolean>>)
    };
    dispatch({
        type: ActionType.SET_LOADING_SPECIAL_ATTRIBUTES,
        loadingSpecialAttributes: newAttributesLoading
    });
};

const getDisplayFeaturesFromUpdatedFeatures = (stateFeatures: DisplayFeature[], updatedFeatures: Feature[]): DisplayFeature[] => {
    return stateFeatures.map(feature => {
        const newFeature = updatedFeatures.find(updatedFeature => updatedFeature.id === feature.id);
        if (newFeature) {
            const allIssues = [newFeature.issues ?? []].concat(Object.values(newFeature.attributes).map(attr => attr.issues))
                .reduce((prev, curr) => prev.concat(curr), []);
            return {
                ...feature,
                geometry: newFeature.geometry,
                locational: newFeature.locational,
                issues: {
                    notabenes: (allIssues).filter(issue => issue.severity === 'NOTABENE'),
                    warnings: (allIssues).filter(issue => issue.severity === 'WARNING'),
                    errors: (allIssues).filter(issue => issue.severity === 'ERROR')
                },
                missingAttributeTypes: newFeature.missingAttributeTypes,
                comments: newFeature.comments,
                attributes: Object.values(newFeature.attributes).map(attribute => ({
                    ...attribute,
                    issues: {
                        notabenes: (attribute.issues ?? []).filter(issue => issue.severity === 'NOTABENE'),
                        warnings: (attribute.issues ?? []).filter(issue => issue.severity === 'WARNING'),
                        errors: (attribute.issues ?? []).filter(issue => issue.severity === 'ERROR')
                    }
                }))
            };
        }
        return feature;
    });
};

export type EditAttribute = (change: FeatureAttributeChange) => FeatureThunk;
const editAttribute: EditAttribute = (change) => (dispatch, getState, serverHolder) => {
    const state = getState();
    const contractId = state.contractId;
    dispatch(editAttributeLocally(change));
    dispatch(setAttributesLoading([{
        featureId: change.objectId,
        attributeTypeId: change.attributeTypeId,
        isLoading: true
    }]));
    serverHolder.server.updateFeatures(contractId, [change])
        .then((updatedFeatures) => {
                const newFeatures: DisplayFeature[] = getDisplayFeaturesFromUpdatedFeatures(state.features, updatedFeatures);
                dispatch(setFeatures(newFeatures));
            },
            err => dispatch(handleError({contractId, change}, 'Error editing attribute'))
        ).then(() => {
        const preserveFocusData = new PreserveFocusData(change.objectId, true);
        dispatch(preserveFocus(preserveFocusData));
    })
        .finally(() => {
            dispatch(setAttributesLoading([{
                featureId: change.objectId,
                attributeTypeId: change.attributeTypeId,
                isLoading: false
            }]));
            dispatch(stopFetching());
        });
};

export type CopyAttributeValueToAllFeaturesOfType = (sourceFeatureId: string, attributeTypeId: number) => FeatureThunk;
export const copyAttributeValueToAllFeaturesOfType: CopyAttributeValueToAllFeaturesOfType = (sourceFeatureId, attributeTypeId) => (dispatch, getState, serverHolder) => {
    const { contractId, features } = getState();
    dispatch({
        type: ActionType.COPY_ATTRIBUTE_VALUE
    });
    dispatch(startFetching());
    dispatch(setAttributesLoading(features.filter(feature => feature.id !== sourceFeatureId).map(feature => ({featureId: feature.id, attributeTypeId, isLoading: true}))));
    serverHolder.server.updateAllFeaturesWithAttributeValue(contractId, sourceFeatureId, attributeTypeId, features.map(feature => feature.id))
        .then(updatedFeatures => {
            const newFeatures: DisplayFeature[] = getDisplayFeaturesFromUpdatedFeatures(features, updatedFeatures);
            dispatch(setFeatures(newFeatures));
        }, () => dispatch(handleError({contractId}, 'Error copying attribute value')))
        .finally(() => {
            dispatch(stopFetching());
            dispatch(setAttributesLoading(features.filter(feature => feature.id !== sourceFeatureId).map(feature => ({featureId: feature.id, attributeTypeId, isLoading: false}))));
        });
};

export type CopyAttributeValue = (changes: FeatureAttributeChange[]) => FeatureThunk;
export const copyAttributeValue: CopyAttributeValue = (changes) => (dispatch, getState, serverHolder) => {
    const state = getState();
    const contractId = getState().contractId;
    dispatch({
        type: ActionType.COPY_ATTRIBUTE_VALUE
    });
    dispatch(setAttributesLoading(changes.map(change => ({featureId: change.objectId, attributeTypeId: change.attributeTypeId, isLoading: true}))));
    serverHolder.server.updateFeatures(contractId, changes)
        .then((updatedFeatures) => {
                const newFeatures: DisplayFeature[] = getDisplayFeaturesFromUpdatedFeatures(state.features, updatedFeatures);
                dispatch(setFeatures(newFeatures));
            },
            err => dispatch(handleError({contractId, changes}, 'Error copying attribute value')))
        .finally(() => {
            dispatch(setAttributesLoading(changes.map(change => ({featureId: change.objectId, attributeTypeId: change.attributeTypeId, isLoading: false}))));
        });
};


export type ToggleAllFeatureTypeLocks = (lockState: LockState) => FeatureThunk;
export const toggleAllFeatureTypeLocks: ToggleAllFeatureTypeLocks = (lockState) => (dispatch, getState, serverHolder) => {
    const state = getState();
    const contractId = state.contractId;
    const selectedFeatureType = state.selectedFeatureType;
    serverHolder.server.setContractLocks(contractId, lockState).then(() => {
        dispatch(requestContract(contractId));
        if (selectedFeatureType != null) {
            dispatch(reloadSelectedFeatures(contractId, selectedFeatureType.typeId));
        }
    });
};

export type LockSelectedFeatureType = (lock: boolean) => FeatureThunk;
export const lockSelectedFeatureType: LockSelectedFeatureType = (lock) => (dispatch, getState, serverHolder) => {
    const state = getState();
    const contractId = state.contractId;
    const selectedFeatureType = state.selectedFeatureType;
    const lockState = lock ? LockState.LOCKED : LockState.OPEN;
    if (selectedFeatureType) {
        serverHolder.server.updateContractLock(contractId, selectedFeatureType.destination, selectedFeatureType.typeId, lockState)
            .then(() => reloadSummaryAndSelectedFeatures(dispatch, contractId, selectedFeatureType, state.additionalSelectedFeatureTypes),
                err => dispatch(handleError({contractId, lock}, 'Error toggling featuretype lock')));
    }

};

export type ToggleFeatureLock = (featureId: string, isLocked: boolean) => FeatureThunk;
export const toggleFeatureLock: ToggleFeatureLock = (featureId, isLocked) => (dispatch) => {
    dispatch({
        type: ActionType.LOCK_FEATURE,
        featureId,
        isLocked
    });
    dispatch(lockFeature(featureId, isLocked));
};

export type LockFeature = (featureId: string, isLocked: boolean) => FeatureThunk;
const lockFeature: LockFeature = (featureId, isLocked) => (dispatch, getState, serverHolder) => {
    const state = getState();
    const contractId = state.contractId;
    const selectedFeatureType = state.selectedFeatureType;
    const lockState = isLocked ? LockState.LOCKED : LockState.OPEN;
    serverHolder.server.updateContractFeatureLock(contractId, selectedFeatureType.destination, selectedFeatureType.typeId, featureId, lockState)
        .then(() => reloadSummaryAndSelectedFeatures(dispatch, contractId, selectedFeatureType, state.additionalSelectedFeatureTypes),
            err => dispatch(handleError({contractId, featureId}, 'Error toggling feature lock')));
};

const createOrderedCommentsFromCommentList = (dataCatalog: datacatalog, featureValues: Record<string, {featureName: string, featureTypeId: number}>, incomingComments: Comment[], existingComments: OrderedComments = {}): OrderedComments => {
    if (!dataCatalog) {
        return {};
    }

    return incomingComments.reduce((holder: OrderedComments, currentComment: Comment) => {
            const isFeatureTypeComment = currentComment.objectType === 'FEATURE_TYPE';
            const commentParent = isFeatureTypeComment
                ? currentComment.objectId.split(currentComment.destination + '-')[1]
                : currentComment.objectId;
            if (isFeatureTypeComment) {
                const featureTypeId = Number.parseInt(commentParent, 10);
                if (Number.isNaN(featureTypeId)) {
                    return holder;
                }
                return {
                    ...holder,
                    [featureTypeId]: holder[featureTypeId] ? {
                        ...holder[featureTypeId],
                        comments: [...holder[featureTypeId].comments, currentComment]
                    } : {
                        featureTypeName: dataCatalog.getFeatureTypeName(featureTypeId, currentComment.destination),
                        comments: [currentComment],
                        features: {}
                    }
                };
            } else if (currentComment.objectType === 'FEATURE') {
                const {featureName, featureTypeId} = featureValues[commentParent];
                return {
                    ...holder,
                    [featureTypeId]: holder[featureTypeId] ? {
                        ...holder[featureTypeId],
                        comments: holder[featureTypeId].comments,
                        features: {
                            ...holder[featureTypeId].features,
                            [commentParent]: {
                                featureName,
                                comments: (holder[featureTypeId].features[commentParent] ? [...holder[featureTypeId].features[commentParent].comments, currentComment] : [currentComment])
                            }
                        }
                    } : {
                        featureTypeName: dataCatalog.getFeatureTypeName(featureTypeId, currentComment.destination),
                        comments: [],
                        features: {
                            [commentParent]: {
                                featureName,
                                comments: [currentComment]
                            }
                        }
                    }
                };
            } else if (currentComment.objectType === 'PROJECT') {
                return {
                    ...holder,
                    [0]: holder[0] ? {
                        ...holder[0],
                        comments: ([...holder[0].comments, currentComment])
                    } : {
                        featureTypeName: 'Prosjektkommentarer',
                        comments: [currentComment],
                        features: {}
                    }
                };
            }
            return holder;
        }, existingComments);
};

const removeComments = (existingComments: OrderedComments, toRemove: string[]): OrderedComments => {
    return Object.entries(existingComments)
        .map(([id, typeComments]) => ({
                [Number.parseInt(id, 10)]: {
                    ...typeComments,
                    comments: typeComments.comments.filter((comment) => !toRemove.includes(comment.id)),
                    features: Object.entries(typeComments.features)
                        .map(([featureId, featureComments]): Record<string, FeatureComments> => ({
                            [featureId]: {
                                ...featureComments,
                                comments: featureComments.comments.filter(comment => !toRemove.includes(comment.id))
                            }
                        }))
                        .reduce((prev, curr) => ({...prev, ...curr}), {})
                }
            })
        )
        .reduce((prev: OrderedComments, curr) => ({...prev, ...curr}), {});
};

export type OnDeleteComments = (commentIds: string[]) => FeatureThunk;
export const onDeleteComments: OnDeleteComments = (commentIds) => (dispatch, getState, serverHolder) => {
    const state = getState();
    const contractId = state.contractId;
    dispatch({
        type: ActionType.DELETE_COMMENTS,
        commentIds
    });
    const newComments = removeComments(state.comments, commentIds);
    dispatch(setComments(newComments));
    serverHolder.server.deleteComments(contractId, commentIds)
        .catch(err => {
            dispatch(setComments(state.comments));
            dispatch(handleError({contractId, commentIds}, 'Kunne ikke fjerne kommentarer'));
        });
};

export type OnNewFeatureTypeComment = (comment: string, isError: boolean, copyComment: boolean, featureTypeId: number) => FeatureThunk;
export const onNewFeatureTypeComment: OnNewFeatureTypeComment = (comment , isError , copyComment, featureTypeId) => (dispatch, getState, serverHolder) => {
    const state = getState();
    const selectedFeatureType = [state.selectedFeatureType, ...state.additionalSelectedFeatureTypes].find(type => type.typeId === featureTypeId);
    if (!selectedFeatureType) {
        serverHolder.server.messages.warning('Kunne ikke opprette typekommentar, typen er ikke registrert');
        return;
    }
    const contractId = state.contractId;
    const fullComment: Comment = {
        contractId,
        tempId: generateUUID(),
        objectId: selectedFeatureType.destination + '-' + selectedFeatureType.typeId,
        objectType: 'FEATURE_TYPE',
        username: state.user.username,
        destination: selectedFeatureType.destination,
        error: isError,
        comment,
        id: null,
        createdInstant: null
    };

    serverHolder.server.saveComments([fullComment])
        .then((updatedComments) => {
                const newComments = createOrderedCommentsFromCommentList(state.datacatalog, {}, updatedComments, state.comments);
                dispatch(setComments(newComments));
            },
            err => dispatch(handleError({contractId, fullComment}, 'Error saving comment')));
};

export type OnNewFeatureComment = (submitComment: SubmitComment) => FeatureThunk;
export const onNewFeatureComment: OnNewFeatureComment = (submitComment) => (dispatch, getState, serverHolder) => {
    const state = getState();
    const {
        contractId,
        objectId,
        objectType,
        username,
        destination,
        error,
        comment
    } = submitComment;
    const fullComment: Comment = {
        contractId, objectId, objectType, username, destination, error, comment, id: null, tempId: generateUUID(), createdInstant: null
    };
    dispatch({
        type: ActionType.COMMENT_FEATURE,
        comment: fullComment
    });
    let commentsToSave = [fullComment];
    if (submitComment.copyComment) {
        commentsToSave = commentsToSave.concat(
            state.selectedFeatures
                .filter(sf => sf !== objectId)
                .map(featureId => ({contractId, objectId: featureId, objectType, username, destination, error, comment, id: null, tempId: generateUUID(), createdInstant: null})));
    }

    const featureNames = commentsToSave.reduce((prev: Record<string, { featureName: string, featureTypeId: number }>, curr) => {
        const feature = state.features.find(possibleFeature => possibleFeature.id === curr.objectId);
        if (feature) {
            return {
                ...prev,
                [curr.objectId]: {
                    featureName: feature.name,
                    featureTypeId: feature.typeId
                }
            };
        }
        return prev;
    }, {});

    serverHolder.server.saveComments(commentsToSave)
        .then((updatedComments) => {
                const newComments = createOrderedCommentsFromCommentList(state.datacatalog, featureNames, updatedComments, state.comments);
                dispatch(setComments(newComments));
            },
            err => dispatch(handleError({contractId, submitComment}, 'Error saving feature comment')));
};

type FetchFeatures = (contractId: string, featureTypeId: number, onReceiveFeatures?: Function) => CommonThunk;
export const fetchFeatures: FetchFeatures = (contractId, featureTypeId, onReceiveFeatures = receiveFeatures) => (dispatch, getState, serverHolder) => {
    const state = getState();
    const paging = {
        page: undefined as number | undefined,
        pageSize: undefined as number | undefined,
        order: undefined as SortSetting | undefined,
        search: undefined as string | undefined
    };
    if ('featuresPage' in state) {
        paging.page = state.featuresPage;
    }
    if ('featuresPageSize' in state) {
        paging.pageSize = state.featuresPageSize;
    }
    if ('sortSetting' in state && state.sortSetting) {
        paging.order = state.sortSetting;
    }
    if ('featureSearchString' in state && state.featureSearchString.length > 0) {
        paging.search = state.featureSearchString;
    }
    serverHolder.server.getFeatures(contractId, featureTypeId, paging)
        .then(type => {
            type.features
                .filter(feature => !!feature.locational)
                .forEach((f: DisplayFeature) => {
                    f.roads = toRoadList(f.locational);
                });
            dispatch(onReceiveFeatures(featureTypeId, type));
            if (onReceiveFeatures === receiveFeatures) {

                const allComments: Comment[] = [
                    ...type.comments,
                    ...type.features.map(feature => feature.comments)
                        .reduce((prev, curr) => prev.concat(curr), [])
                ];
                const featureValues = type.features.reduce((prev: Record<string, {featureName: string, featureTypeId: number}>, curr) => ({...prev, [curr.id]: {featureName: curr.name, featureTypeId: curr.typeId}}), {});

                const newFeatures: DisplayFeature[] = type.features as DisplayFeature[];
                dispatch(setFeatures(newFeatures));

                const existingComments = {};
                const orderedComments = createOrderedCommentsFromCommentList(state.datacatalog, featureValues, allComments, existingComments);
                dispatch(setComments(orderedComments));
            }
        }, () => dispatch(handleError({contractId, featureTypeId}, 'Error receive features')))
        .finally(() => dispatch(stopFetching));
};

const receiveFeatures = (featureTypeId: number, featureType: DisplayFeatureType): AnyAction => ({
    type: ActionType.RECEIVE_FEATURE_TYPE,
    featureType
});

const receiveTargetAssociationCandidates = (featureTypeId: number, featureType: DisplayFeatureType): AnyAction => ({
    type: ActionType.ASSOCIATIONS_RECEIVE_POTENTIAL_CHILDREN,
    features: featureType.features
});


const clearTargetFeatures = (): AnyAction => ({
    type: ActionType.ASSOCIATIONS_CLEAR_POTENTIAL_CHILDREN
});

export type ReceiveAdditionalFeatureType = (featureTypeId: number, featureType: DisplayFeatureType) => FeatureThunk;
const receiveAdditionalFeatureType: ReceiveAdditionalFeatureType = (featureTypeId, featureType) => (dispatch, getState) => {
    const state: FeaturesState = getState();

    const existingIndex = state.additionalSelectedFeatureTypes.findIndex(type => type.typeId === featureTypeId);

    let newTypes: typeof state.additionalSelectedFeatureTypes;

    if (existingIndex !== -1) {                                    // Updating existing feature type
        newTypes = state.additionalSelectedFeatureTypes.slice();
        newTypes[existingIndex] = featureType;
    } else {                                                // Adding a new feature type
        newTypes = state.additionalSelectedFeatureTypes.concat(featureType);
    }

    dispatch({
        type: ActionType.RECEIVE_ADDITIONAL_FEATURE_TYPE,
        additionalSelectedFeatureTypes: newTypes
    });
};

export type RemoveAdditionalFeatureType = (featureTypeId: number) => FeatureThunk;
const removeAdditionalFeatureType: RemoveAdditionalFeatureType = (featureTypeId) => (dispatch, getState) => {
    const state: FeaturesState = getState();

    dispatch({
        type: ActionType.RECEIVE_ADDITIONAL_FEATURE_TYPE,
        additionalSelectedFeatureTypes: state.additionalSelectedFeatureTypes.filter(ft => ft.typeId != featureTypeId)
    });
};

export type DeleteFeature = (contractId: string, featureIds: string[]) => FeatureThunk;
const deleteFeature: DeleteFeature = (contractId, featureIds) => (dispatch, getState, serverHolder) => {
    const server = serverHolder.server;
    const {selectedFeatureType} = getState();
    dispatch(startFetching());
    server.deleteFeatures(contractId, featureIds)
        .then(
            () => {
                if (selectedFeatureType) {
                    dispatch(fetchFeatures(contractId, selectedFeatureType?.typeId));
                }
                dispatch(featuresWasDeleted(contractId, featureIds));
            },
            err => {
                dispatch(stopFetching());
                dispatch(handleError({contractId, featureIds}, 'Error deleting feature'));
            }
        );
};

type FeaturesWasDeleted = (contractId: string, featureIds: string[]) => FeatureThunk;
const featuresWasDeleted: FeaturesWasDeleted = (contractId, featureIds) => (dispatch, getState) => {
    dispatch(requestContract(contractId));
    dispatch({
        type: ActionType.FEATURES_DELETED,
        featureIds
    });
    dispatch({
        type: ActionType.UNSELECT_FEATURES,
        featureIds
    });
    if (getState().selectedFeatureType.features.length == 0) {
        dispatch({
            type: ActionType.UNSELECT_FEATURE_TYPE
        });
    }
};

export type UnselectFeatureType = () => AssociationsThunk;
export const unselectFeatureType: UnselectFeatureType = () => (dispatch) => {
    dispatch({
        type: ActionType.UNSELECT_FEATURE_TYPE
    });
};

export type ToggleFeatureSelected = (feature: DisplayFeature) => FeatureThunk;
export const toggleFeatureSelected: ToggleFeatureSelected = (feature) => (dispatch, getState) => {
    const state = getState();
    const selectedFeatures = state.selectedFeatures;

    const isSelect = selectedFeatures.indexOf(feature.id) == -1;
    dispatch({
        type: isSelect ? ActionType.SELECT_FEATURES : ActionType.UNSELECT_FEATURES,
        featureIds: [feature.id]
    });

};

// Used from both assoc and feature
export type  SetSelectFeatures = (featureIds: string[]) => CommonThunk;
export const setSelectFeatures: SetSelectFeatures = (featureIds) => (dispatch) => {
    dispatch({
        type: ActionType.SET_SELECTED_FEATURES,
        featureIds
    });
};


export type SelectFeatures = (featureIds: string[]) => FeatureThunk;
export const selectFeatures: SelectFeatures = (featureIds) => (dispatch) => {
    dispatch({
        type: ActionType.SELECT_FEATURES,
        featureIds
    });
};

export type DeSelectFeatures = (featureIds: string[]) => FeatureThunk;
export const deSelectFeatures: DeSelectFeatures = (featureIds) => (dispatch) => {
    dispatch({
        type: ActionType.UNSELECT_FEATURES,
        featureIds
    });
};

export type  DeSelectAllFeatures = () => FeatureThunk;
export const deselectAllFeatures: DeSelectFeatures = () => (dispatch) => {
    dispatch({
        type: ActionType.FEATURETAB3_DESELECT_ALL_FEATURES
    });
};

export type EnableEditFeatureGeometry = (featureId: string) => FeatureThunk;
export const enableEditFeatureGeometry: EnableEditFeatureGeometry = (featureId) => (dispatch) => {
    dispatch({
        type: ActionType.SELECT_FEATURES,
        featureIds: [featureId]
    });
    dispatch({
        type: ActionType.ENABLE_GEOMETRY_EDIT,
        featureId
    });
};

export type EditFeatureGeometry = (featureId: string, wkt: string, shouldRelocalize: boolean) => FeatureThunk;
export const editFeatureGeometry: EditFeatureGeometry = (featureId, wkt, shouldRelocalize) => (dispatch, getState, serverHolder) => {
    const selectedType = getState().selectedFeatureType;
    const contractId = getState().contractId;
    dispatch({
        type: ActionType.CLOSING_FEATURE_GEOMETRY_EDITOR
    });

    serverHolder.server.updateFeatureGeometry(contractId, selectedType.typeId, featureId, wkt, shouldRelocalize).then(() => {
        dispatch({
            type: ActionType.FEATURETAB3_SET_TYPE_MODIFIED,
            typeId: selectedType.typeId
        });

        const reload = setInterval(() => {
            serverHolder.server.getPendingAutoLocalizingCount(contractId).then(count => {
                if (count == 0) {
                    dispatch(reloadSelectedFeatures(contractId, selectedType.typeId));
                    dispatch(selectFeatureType(selectedType.typeId, true));
                    clearInterval(reload);
                }
            });
        }, 500);
    });
};
export type ReloadExistingFeatures = (boundingBox: BoundingBox) => FeatureThunk;
export const reloadExistingFeatures: ReloadExistingFeatures = (boundingBox) => (dispatch, getState) => {
    dispatch(hideExistingFeatures());
    dispatch(showExistingFeatures(boundingBox));
};
export type ExitGeometryEditor = () => FeatureThunk;
export const exitGeometryEditor: ExitGeometryEditor = () => (dispatch) => {
    dispatch({
        type: ActionType.CLOSING_FEATURE_GEOMETRY_EDITOR
    });
};

export type ToggleShowExistingFeatures = (boundingbox: BoundingBox, closeEnough: boolean) => FeatureThunk;
export const toggleShowExistingFeatures: ToggleShowExistingFeatures = (boundingbox, closeEnough) => (dispatch, getState, serverHolder) => {
    const state: FeaturesState = getState();
    if (state.isShowingExistingFeatures) {
        dispatch(hideExistingFeatures());
    } else {
        if (closeEnough) {
            dispatch(enableShowExistingFeatures());
            dispatch(showExistingFeatures(boundingbox));
        } else {
            dispatch(showInfoMessage('Du må zoome inn for å se eksisterende vegobjekt.'));
        }
    }
};

export type EnableShowExistingFeatures = () => FeatureThunk;
export const enableShowExistingFeatures: EnableShowExistingFeatures = () => (dispatch, getState) => {
    dispatch({
        type: ActionType.ENABLE_SHOW_EXISTING_FEATURES
    });
};

export type HideExistingFeatures = () => FeatureThunk;
const hideExistingFeatures: HideExistingFeatures = () => (dispatch) => {
    dispatch({
        type: ActionType.REMOVE_EXISTING_FEATURES
    });
};



export type EmptySensitiveAttributeTypes = () => FeatureThunk;
export const emptySensitiveAttributeTypes: EmptySensitiveAttributeTypes = () => (dispatch, getState, serverHolder) => {

    dispatch({
        type: ActionType.FEATURETAB3_SET_MISSING_ATTRIBUTE_TYPES,
        attributeTypes: []
    });
    dispatch({
        type: ActionType.URL_HAS_SENSITIVE_ATTRIBUTES,
        hasSensitiveAttributes: false
    });
};

export type CheckForUnauthorizedSensitiveAttributesOnFeature = (url: string) => FeatureThunk;
export const checkForUnauthorizedSensitiveAttributesOnFeature: CheckForUnauthorizedSensitiveAttributesOnFeature = (url) => (dispatch, getState, serverHolder) => {

    dispatch({
        type: ActionType.FEATURETAB3_SET_FETCHING_MISSING_ATTRIBUTE_TYPES,
        isFetching: true
    });

    serverHolder.server.getMissingAttributeTypes(getState().contractId, url).then(response => {

        const missingAttributeTypes: AttributeType[] = [];
        response.features.forEach(feature => feature.missingAttributeTypes.forEach(missingAttributeType => {
            if (!missingAttributeTypes.some(attributeType => attributeType.id === missingAttributeType.id)) {
                missingAttributeTypes.push(missingAttributeType);
            }
        }));

        dispatch({
            type: ActionType.FEATURETAB3_SET_MISSING_ATTRIBUTE_TYPES,
            attributeTypes: missingAttributeTypes
        });

        dispatch({
            type: ActionType.FEATURETAB3_SET_FETCHING_MISSING_ATTRIBUTE_TYPES,
            isFetching: false
        });
    },
        err => {
            dispatch({
                type: ActionType.FEATURETAB3_SET_FETCHING_MISSING_ATTRIBUTE_TYPES,
                isFetching: false
            });
        }
    );
};

export type CheckURLForSensitiveAttributes = (url: string, operation: Operation) => FeatureThunk;
export const checkUrlForSensitiveAttributes: CheckURLForSensitiveAttributes = (url, operation, callback?: (sensitive: boolean) => void) => (dispatch, getState, serverHolder) => {
    dispatch({
        type: ActionType.FEATURETAB3_SET_FETCHING_SENSITIVE_ATTRIBUTE_TYPES,
        isFetching: true
    });
    serverHolder.server.checkSensitiveAttributeTypes(getState().contractId, url, operation)
        .then(sensitive => {
            dispatch(setURLHasSensitiveAttributes(sensitive));
            if (callback) {
                callback(sensitive);
            }
        })
        .finally(() => {
            dispatch({
                type: ActionType.FEATURETAB3_SET_FETCHING_SENSITIVE_ATTRIBUTE_TYPES,
                isFetching: false
            });
        });
};

export type ImportVegkartFeatures = (url: string, operation: string) => FeatureThunk;
export const importVegkartFeatures: ImportVegkartFeatures = (url, operation) => (dispatch, getState, serverHolder) => {
    dispatch(startFetching());
    serverHolder.server.addExistingFeatures(getState().contractId, url, operation).then(response => {
            dispatch(stopFetching());
            if (response.success) {
                serverHolder.contract.showMessage.success(response.message);
            } else {
                serverHolder.contract.showMessage.warning(response.message);
            }
            if (!!getState().selectedFeatureTypeId) {
                dispatch(fetchFeatures(getState().contractId, getState().selectedFeatureTypeId));
            }
            dispatch(requestContract(getState().contractId));
        },
        err => {
            dispatch(stopFetching());
            serverHolder.contract.showMessage.danger('Klarer ikke å få noe fornuftig ut av URLen du prøver å importere fra. Sjekk at den er riktig.');
            dispatch(handleError({}, 'Error importing vegkart features'));
        }
    );
};


export type ShowExistingFeatures = (boundingbox: BoundingBox) => FeatureThunk;
export const showExistingFeatures: ShowExistingFeatures = (boundingbox) => (dispatch, getState, serverHolder) => {
    const state: FeaturesState = getState();
    if (state.selectedFeatureType != null) {
        dispatch({
            type: ActionType.SHOW_EXISTING_FEATURES
        });
        serverHolder.nvdbapi.getObjectsOfTypeInArea(state.selectedFeatureType.typeId, boundingbox)
            .then(combinedFeatures => {
                    dispatch(refreshDeletions());
                    dispatch({
                        type: ActionType.RECEIVE_EXISTING_FEATURES,
                        existingFeatures: combinedFeatures
                    });
                },
                err => dispatch(handleError({}, 'Error ShowExistingFeatures')));
    }
};

export type showNvdbFeatures = (distance: number) => AssociationsThunk;
export const showNvdbFeatures: showNvdbFeatures = (distance) => (dispatch, getState, serverHolder) => {
    const typeId = getState().selectedAssociationTargetType.typeId;
    const wkt = getState().selectedSourceFeature.geometry.wkt;

    const featurePosUtm33 = WKTParser.parse(wkt);
    const bbox = Terraformer.Tools.calculateBounds(featurePosUtm33);

    const margin = Number(distance);
    const boundingbox = new BoundingBox({lat: bbox[3] + margin, lng: bbox[2] + margin}, {lat: bbox[1] - margin, lng: bbox[0] - margin}, '6173');

    const includeRelations = getState().tab == 'PROJECT_TO_NVDB';

    serverHolder.nvdbapi.getObjectsOfTypeInArea(typeId, boundingbox, includeRelations).then((features) => {
            dispatch({
                type: ActionType.ASSOCIATIONS_RECEIVE_POTENTIAL_CHILDREN,
                features
            });
        },
        err => dispatch(handleError({}, 'Error ShowExistingFeatures')));
};

export type ShowEmptyTargetList = () => AssociationsThunk;
const showEmptyTargetList: ShowEmptyTargetList = () => (dispatch) => {
    dispatch({
        type: ActionType.ASSOCIATIONS_RECEIVE_POTENTIAL_CHILDREN,
        features: []
    });
};


export type TabChange = (tab: AssociationScope) => AssociationsThunk;
export const tabChange: TabChange = (tab) => (dispatch, getState) => {
    dispatch({
        type: ActionType.CHANGE_ACTIVE_TAB,
        tab
    });

    dispatch(clearTargetFeatures());
    dispatch(clearSelectedTargetFeatureType());

    if (!!getState().selectedSourceFeature) {
        dispatch(requestPotentialAssociationChildrenTypes(getState().selectedSourceFeature.typeId));
    }

};

export type importNvdbFeatureByIdT = (typeId: number, nvdbFeatureId: string, operation: Operation) => FeatureThunk;
export const importNvdbFeatureById: importNvdbFeatureByIdT = (typeId, nvdbFeatureId, operation) => (dispatch, getState, serverHolder) => {
    const contractId = getState().contractId;
    serverHolder.server.importNvdbFeatureById(contractId, typeId, nvdbFeatureId, operation)
        .then((result) => {
                const response = (result.data as MessageResponse);
                if (response.success) {
                    dispatch(fetchFeatures(getState().contractId, getState().selectedFeatureTypeId));
                    dispatch(requestContract(getState().contractId));
                } else {
                    serverHolder.contract.showMessage.danger(response.message);
                    dispatch(handleError({}, response.message));
                }
            },
            err => {
                dispatch(handleError({}, 'Error importing vegkart features'));
            });
};

export type importNvdbFeatureByIdAsTypeT = (typeId: number, nvdbFeatureId: string, newtypeId: number) => FeatureThunk;
export const importNvdbFeatureByIdAsType: importNvdbFeatureByIdAsTypeT = (typeId, nvdbFeatureId, newtypeId) => (dispatch, getState, serverHolder) => {
    const contractId = getState().contractId;
    serverHolder.server.importNvdbFeatureByIdAsType(contractId, typeId, nvdbFeatureId, newtypeId)
        .then(() => {
            dispatch(fetchFeatures(getState().contractId, getState().selectedFeatureTypeId));
            dispatch(requestContract(getState().contractId));
        });
};

export type CopyFeatures = (features: DisplayFeature[]) => FeatureThunk;
export const copyFeatures: CopyFeatures = (features) => (dispatch, getState, serverHolder) => {
    const contractId = getState().contractId;
    if (!getState().selectedFeatureType.isLocked) {
        serverHolder.server.copyDatafangstFeatures(contractId, features.map((f) => f.id))
            .then(() => {
                    dispatch(fetchFeatures(getState().contractId, getState().selectedFeatureTypeId));
                    dispatch(requestContract(getState().contractId));
                },
                () => dispatch(handleError({contractId, features}, 'Error copying objects')));
    } else {
        dispatch(handleError({features}, 'Objekttype låst'));
    }
};

export type CopyFeatureWithTypePopup = () => FeatureThunk;
export const copyFeatureWithTypePopup: CopyFeatureWithTypePopup = () => (dispatch, getState, serverHolder: ServerHolder) => {
    dispatch({
        type: ActionType.SET_POPUP,
        popup: PopupType.COPY_FEATURE_WITH_TYPE
    });
};

export type ClearPopup = () => FeatureThunk;
export const clearPopup: ClearPopup = () => (dispatch) => {
    dispatch({
        type: ActionType.SET_POPUP,
        popup: PopupType.NONE
    });
};

export type CopyGeometry = (selectedFeatures: DisplayFeature[], typeId: number) => FeatureThunk;
export const copyGeometry: CopyGeometry = (selectedFeatures, typeId) => (dispatch, getState, serverHolder) => {
    const contractId = getState().contractId;
    const featureType = getState().selectedFeatureType;
    if (!featureType.isLocked) {
        serverHolder.server.copyFeatureGeometry(contractId, selectedFeatures.map(f => f.id), typeId)
            .then(() => {
                    dispatch(fetchFeatures(getState().contractId, getState().selectedFeatureTypeId));
                    dispatch(requestContract(getState().contractId));
                },
                () => dispatch(handleError({contractId, selectedFeatures}, 'Error copying objects')));
    } else {
        dispatch(handleError({featureType}, 'Objekttype låst'));
    }
};

export type CutFeature = (feature: DisplayFeature, position: L.LatLng) => FeatureThunk;
export const cutFeature: CutFeature = (feature, position) => (dispatch, getState, serverHolder) => {
    const contractId = getState().contractId;
    dispatch(startFetching());
    serverHolder.server.cutFeatureGeometry(getState().contractId, feature.id, position)
        .then(() => {
            // Remove selection for cut feature, as it no longer exists as it is
            if (feature.isSelected) {
                dispatch(deSelectFeatures([feature.id]));
            }
            // Reload features from server
            dispatch(fetchFeatures(contractId, getState().selectedFeatureTypeId));
            dispatch(requestContract(contractId));
        })
        .catch(() => dispatch(handleError({contractId, feature}, 'Error cutting object')));
};

export type RefreshDeletions = () => FeatureThunk;
export const refreshDeletions: RefreshDeletions = () => (dispatch, getState) => {
    const closings: DisplayFeature[] = [];
    getState().selectedFeatureType.features.forEach(feature => {
        if (feature.operation == 'CLOSE') {
            closings.push(feature);
        }
    });
    dispatch({
        type: ActionType.RECEIVE_CLOSINGS,
        closings
    });
};

export const handleError = (params: any, message: string) => ({
    type: ActionType.ERROR,
    params,
    message
});

export type ToggleFullscreen = () => FeatureThunk;
export const toggleFullscreen: ToggleFullscreen = () => (dispatch) => {
    dispatch({
        type: ActionType.TOGGLE_FULLSCREEN
    });
};

export type ToggleSplitscreen = () => FeatureThunk;
export const toggleSplitscreen: ToggleSplitscreen = () => (dispatch) => {
    dispatch({
        type: ActionType.TOGGLE_SPLITSCREEN
    });
};

export type ChangeSceneData = (sceneData: SceneData) => FeatureThunk;
export const changeSceneData: ChangeSceneData = (sceneData) => (dispatch) => {
    dispatch({
        type: ActionType.CHANGE_SCENE_DATA,
        sceneData
    });
};

export type ChangeGround3dData = (ground3dData: Ground3dData) => FeatureThunk;
export const changeGround3dData: ChangeGround3dData = (ground3dData) => (dispatch) => {
    dispatch({
        type: ActionType.CHANGE_GROUND3D_DATA,
        ground3dData
    });
};

export type FetchDatacatalog = () => FeatureThunk;
export const fetchDatacatalog: FetchDatacatalog = () => (dispatch, getState, serverHolder) => {
    dispatch({
        type: ActionType.FETCH_DATACATALOG,
        datacatalog: serverHolder.datacatalog
    });
};

export type StartFetching = () => FeatureThunk;
export const startFetching: StartFetching = () => (dispatch) => {
    dispatch({
        type: ActionType.START_FETCHING
    });
};

export type StopFetching = () => FeatureThunk;
export const stopFetching: StopFetching = () => (dispatch) => {
    dispatch({
        type: ActionType.STOP_FETCHING
    });
};

export type SetCopyGeometryVisible = (isVisible: boolean) => FeatureThunk;
export const setCopyGeometryVisible: SetCopyGeometryVisible = (isVisible) => (dispatch => {
    dispatch({
        type: ActionType.FEATURETAB3_SET_COPY_GEOMETRY_MODAL_VISIBLE,
        isVisible
    });
});

export type SetURLHasSensitiveAttributes = (sensitive: boolean) => FeatureThunk;
export const setURLHasSensitiveAttributes: SetURLHasSensitiveAttributes = sensitive => dispatch => {
    dispatch({
        type: ActionType.URL_HAS_SENSITIVE_ATTRIBUTES,
        hasSensitiveAttributes: sensitive
    });
};

export type SetPossibleCopiableFeatures = (features: CopiableGeometryFeature[]) => FeatureThunk;
export const setPossibleCopiableFeatures: SetPossibleCopiableFeatures = (features) => (dispatch) => {
    dispatch({
        type: ActionType.FEATURETAB3_SET_COPIABLE_FEATURES,
        features
    });
};

export type SetFetchingCopiableFeatures = (fetching: boolean) => FeatureThunk;
export const setFetchingCopiableFeatures: SetFetchingCopiableFeatures = (fetching) => (dispatch) => {
    dispatch({
        type: ActionType.FEATURETAB3_SET_FETCHING_COPIABLE_FEATURES,
        fetching
    });
};

export type GeneratePossibleCopyOperations = () => FeatureThunk;
export const generatePossibleCopyOperations: GeneratePossibleCopyOperations = () => (dispatch, getState, serverHolder) => {
    const {server} = serverHolder;
    const state = getState();
    if (state.selectedFeatures.length > 0) {
        dispatch(setFetchingCopiableFeatures(true));
        server.getCopiableGeometries(state.contractId, state.selectedFeatures)
            .then(result => {
                dispatch(setPossibleCopiableFeatures(result.data));
            })
            .catch(() => {
                dispatch(setPossibleCopiableFeatures([]));
            })
            .finally(() => {
                dispatch(setFetchingCopiableFeatures(false));
            });
    } else {
        dispatch(setPossibleCopiableFeatures([]));
    }
};

export type CopyFeatureGeometry = (from: string, to: string[]) => FeatureThunk;
export const copyFeatureGeometries: CopyFeatureGeometry = (from, to) => (dispatch, getState, serverHolder) => {
    dispatch({
        type: ActionType.FEATURETAB3_SET_COPYING_GEOMETRY_FEATURES,
        copying: true
    });
    const state = getState();
    const contractId = state.contractId;
    serverHolder.server.copyGeometryBetweenFeatures(contractId, from, to)
        .then(() => {
            // Reload features from server
            const reload = setInterval(() => {
                serverHolder.server.getPendingAutoLocalizingCount(contractId).then(count => {
                    if (count === 0) {
                        dispatch(reloadSelectedFeatures(contractId, state.selectedFeatureTypeId));
                        dispatch(selectFeatureType(state.selectedFeatureTypeId, true));
                        clearInterval(reload);
                    }
                    serverHolder.contract.showMessage.success(`Vegobjektgeometri kopiert til ${to.length} andre objekter.`);
                });
            }, 500);
        })
        .finally(() => {
            dispatch({
                type: ActionType.FEATURETAB3_SET_COPYING_GEOMETRY_FEATURES,
                copying: false
            });
        });
};

export type SetComments = (comments: OrderedComments) => FeatureThunk;
export const setComments: SetComments = (orderedComments) => (dispatch) => dispatch({
    type: ActionType.SET_COMMENTS,
    comments: orderedComments
});

export type SetCommentsModalVisible = (visible: boolean) => FeatureThunk;
export const setCommentsModalVisible: SetCommentsModalVisible = (visible: boolean) => (dispatch) => dispatch({
    type: ActionType.FEATURE_TAB3_SET_COMMENTS_MODAL_VISIBLE,
    visible
});

export type SetCommentsFilter = (filter: string) => FeatureThunk;
export const setCommentsFilter: SetCommentsFilter = (filter) => (dispatch) => dispatch({
    type: ActionType.FEATURE_TAB3_SET_COMMENTS_FILTER,
    filter
});

export type SetMarkedComments = (comments: string[]) => FeatureThunk;
export const setMarkedComments: SetMarkedComments = (markedComments) => (dispatch) => dispatch({
    type: ActionType.FEATURE_TAB3_SET_MARKED_COMMENTS,
    markedComments
});

export type MarkComment = (comments: string) => FeatureThunk;
export const markComment: MarkComment = (toMark) => (dispatch, getState) => {
    const alreadyMarked = getState().markedComments?.some(comment => comment === toMark);
    if (alreadyMarked) {
        dispatch({
            type: ActionType.FEATURE_TAB3_SET_MARKED_COMMENTS,
            markedComments: getState().markedComments?.filter(comment => comment !== toMark) ?? []
        });
    } else {
        dispatch({
            type: ActionType.FEATURE_TAB3_SET_MARKED_COMMENTS,
            markedComments: [...getState().markedComments ?? [], toMark]
        });
    }
};

export type SetFeatureOrTypeIdForComments = (id: string | number | null) => FeatureThunk;
export const setFeatureOrTypeIdForComments: SetFeatureOrTypeIdForComments = (featureOrTypeId) => dispatch => dispatch({
    type: ActionType.FEATURE_TAB3_SET_FEATURE_OR_TYPE_FOR_COMMENTS,
    featureOrTypeId
});

export type GetRoadSegments = (southWestX: number, southWestY: number, northEastX: number, northEastY: number) => FeatureThunk;
export const getRoadSegments: GetRoadSegments = (southWestX: number, southWestY: number, northEastX: number, northEastY: number) => async (dispatch, getState, serverHolder) => {
    const result = await serverHolder.server.getRoadSegmentsInArea(southWestX, southWestY, northEastX, northEastY);
    if (result) {
        dispatch({
            type: ActionType.FEATURE_TAB3_SET_ROAD_REFS,
            roadSegments: result
        });
    }
};

export type SetSelectedRoadSegment = (roadSegment: RoadSegment) => FeatureThunk;
export const setSelectedRoadSegment: SetSelectedRoadSegment = (roadSegment) => async (dispatch, getState, serverHolder) => {
    dispatch({
        type: ActionType.FEATURE_TAB3_SET_SELECTED_ROAD_REF,
        selectedRoadSegment: roadSegment
    });
};

export type SetCreateObjectVisible = (visible: boolean) => FeatureThunk;
export const setCreateObjectVisible: SetCreateObjectVisible = (visible) => dispatch => dispatch({
    type: ActionType.FEATURE_TAB3_SET_CREATE_OBJECT_VISIBLE,
    visible
});

export type SetCreateObjectTypeId = (id: number) => FeatureThunk;
export const setCreateObjectTypeId: SetCreateObjectTypeId = (id) => dispatch => dispatch({
    type: ActionType.FEATURE_TAB3_SET_CREATE_OBJECT_TYPE_ID,
    id
});

export type SetCreateObjectWkt = (wkt: string) => FeatureThunk;
export const setCreateObjectWkt: SetCreateObjectWkt = (wkt) => dispatch => dispatch({
    type: ActionType.FEATURE_TAB3_SET_CREATE_OBJECT_WKT,
    wkt
});

export type SetReferenceError = (error: boolean) => FeatureThunk;
export const setReferenceError: SetReferenceError = (error) => dispatch => dispatch({
    type: ActionType.FEATURE_TAB3_SET_REFERENCE_ERROR,
    error
});

export type SetCreatingObjectGeometry = (creating: GeometryType) => FeatureThunk;
export const setCreatingObjectGeometry: SetCreatingObjectGeometry = (creating) => dispatch => dispatch({
    type: ActionType.FEATURE_TAB3_SET_CREATING_OBJECT_GEOMETRY,
    creating
});

export type GetWktFromReference = (reference: string) => FeatureThunk;
export const getWktFromReference: GetWktFromReference = (reference) => (dispatch, getState, serverHolder) => {
    try {
        serverHolder.nvdbapi.getWktFromReference(reference).then(wkt => {
            dispatch(setCreateObjectWkt(wkt));
            dispatch(setReferenceError(false));
        }, error => {
            dispatch(setReferenceError(true));
        });
    } catch (e) {
        dispatch(setReferenceError(true));
    }
};

export type GetWktFromPoints = (pointWkts: string[]) => FeatureThunk;
export const getWktFromPoints: GetWktFromPoints = (pointWkts) => (dispatch) => {
    dispatch(setCreateObjectWkt(MapUtils.getWktFromUnsortedLinestring(pointWkts)));
};

export type CreateFeature = (typeId: number, name: string, wkt: string, localize: boolean, associate: boolean) => FeatureThunk;
export const createFeature: CreateFeature = (typeId, name, wkt, localize = false, associate = false) => (dispatch, getState, server) => {
    dispatch(startFetching());
    const {contractId, selectedFeatures} = getState();

    server.server.createFeature(contractId, typeId, name, wkt, localize, associate ? selectedFeatures : [])
        .then(({id}) => {
            dispatch(requestContract(contractId));
            return id;
        })
        .then((id) => {
            dispatch(selectFeatureType(typeId, true));
            dispatch(setSelectFeatures([id]));
        })
        .finally(() => {
            dispatch(stopFetching());
        });
};

export type CheckValidRelationship = (parentTypeId: number, childTypeId: number, cb: (valid: boolean) => void) => FeatureThunk;
export const checkValidRelationship: CheckValidRelationship = (parentTypeId, childTypeId, cb) => (dispatch, getState, serverHolder) => {
    serverHolder.server.checkValidRelationship(parentTypeId, childTypeId).then(cb);
};

export type DisplayMissingDirectionMessage = (message: string) => FeatureThunk;
export const displayMissingDirectionMessage: DisplayMissingDirectionMessage = (message) => async (dispatch, getState, serverHolder) => {
    dispatch(
        showInfoMessage(message)
    );
};

const showInfoMessage = (message: string): FeatureThunk => (dispatch, getState, serverHolder) => {
    serverHolder.scope.$applyAsync(() =>
        serverHolder.server.messages.info(message)
    );
};

export type SetPageSize = (size: number) => FeatureThunk;
export const setPageSize: SetPageSize = (size: number) => (dispatch, getState) => {
    const {contractId, selectedFeatureType} = getState();
    if (contractId && selectedFeatureType) {
        dispatch({
            type: ActionType.SET_FEATURES_PAGE_SIZE,
            pageSize: size
        });
    }
};

export type NextPage = () => FeatureThunk;
export const nextPage: NextPage = () => (dispatch, getState) => {
    const {featuresPage, contractId, selectedFeatureType} = getState();
    if (contractId && selectedFeatureType) {
        dispatch(setPage(featuresPage + 1));
    }
};

export type PreviousPage = () => FeatureThunk;
export const previousPage: PreviousPage = () => (dispatch, getState) => {
    const {featuresPage, contractId, selectedFeatureType} = getState();
    if (contractId && selectedFeatureType && featuresPage > 0) {
        dispatch(setPage(featuresPage - 1));
    }
};

export type SetPage = (page: number) => FeatureThunk;
export const setPage: SetPage = (page) => (dispatch, getState) => {
    const {contractId, selectedFeatureType} = getState();
    if (contractId && selectedFeatureType && page >= 0) {
        dispatch({
            type: ActionType.SET_FEATURES_PAGE,
            page
        });
        dispatch(startFetching());
        dispatch(fetchFeatures(contractId, selectedFeatureType.typeId));
    }
};

export type SetFeatureSearchString = (searchString: string) => CommonThunk;
export const setFeatureSearchString: SetFeatureSearchString = (searchString) => (dispatch, getState) => {
    const {contractId, selectedFeatureType} = getState();
    dispatch({
        type: ActionType.SET_FEATURE_SEARCH,
        searchString
    });
    dispatch(startFetching());
    dispatch(fetchFeatures(contractId, selectedFeatureType.typeId));
};
